import { css } from '@emotion/core'
import { colors, measures, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const { unit } = measures

// Mobile header styles (Detail/Navigation pattern)
export const mobileHeader = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #000000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  
  ${MQ.NOT_TABLETS} {
    display: none;
  }
`

export const headerContainer = css`
  display: flex;
  align-items: center;
  padding: ${spacing(4)} ${spacing(2)};
  position: relative;
`

export const backArrow = css`
  color: #ffffff;
  font-size: 22px;
  cursor: pointer;
  user-select: none;
  position: absolute;
  left: ${spacing(2)};
  top: 50%;
  transform: translateY(-50%);
  
  &:hover {
    opacity: 0.8;
  }
`

export const titleContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`

export const headerTitle = css`
  color: ${colors.white100};
  margin: 0;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const contentWrapper = css`
  ${MQ.TABLETS} {
    padding-top: 50px; /* Reduced space for tighter spacing with header */
  }
`

export const panel = css`
  height: 80vh;
  
  ${MQ.TABLETS} {
    height: 100vh;
    background-color: ${colors.black100};
    padding-bottom: 100px; /* Space for bottom navigation */
  }
`
export const title = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  ${MQ.TABLETS} {
    display: none; /* Hide desktop title on mobile - use header instead */
  }
`
export const count = css`
  color: ${colors.white100};
  font-weight: 500;
`

export const grey = css`
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
`

export const margin = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const pageWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const alignRight = css`
  text-align: right;
`

export const buttonContentWrapper = css`
  display: flex;
  justify-content: center;
`
export const wrapperLoader = css`
  height: ${unit}px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const emptyTable = {
  '& .rt-table, & .-loading, & .rt-noData': {
    display: 'none'
  }
}

// Mobile infinite scroll styles
export const movementsContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1.5)};
  padding-bottom: ${spacing(20)}; /* Extra padding for bottom navigation + small gap */
  margin-top: ${spacing(3)};
  
  ${MQ.NOT_TABLETS} {
    display: none;
  }
`

export const movementCard = css`
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: ${spacing(2)};
  padding: ${spacing(2.5)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 80%;
  margin: 0 auto;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.08);
  }
`

export const movementInfo = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(0.5)};
  flex: 1;
`

export const movementType = css`
  color: ${colors.white100};
  margin: 0;
`

export const movementTypeWithLogo = css`
  display: flex;
  align-items: center;
  gap: ${spacing(1)};
`

export const inwinLogo = css`
  width: 16px;
  height: 16px;
  object-fit: contain;
`

export const currentBalanceInwinLogo = css`
  width: 20px;
  height: 20px;
  object-fit: contain;
`

export const movementDate = css`
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
`

export const movementAmount = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 80px;
`

export const positiveAmount = css`
  color: ${colors.greens.green2};
  margin: 0;
`

export const negativeAmount = css`
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
`

export const emptyState = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing(6, 2)};
  text-align: center;
`

export const emptyText = css`
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
`

export const loadingMore = css`
  margin-top: ${spacing(2)};
  padding: ${spacing(2, 0)};
`

export const loadingPlaceholder = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacing(2)};
`

export const loadingText = css`
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
`

export const desktopTable = css`
  display: block;
  
  ${MQ.TABLETS} {
    display: none;
  }
`

export const currentBalanceCard = css`
  background: linear-gradient(135deg, rgba(111, 207, 151, 0.15) 0%, rgba(111, 207, 151, 0.08) 100%);
  border-radius: ${spacing(3)};
  padding: ${spacing(3.5)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 2px solid rgba(111, 207, 151, 0.3);
  width: 85%;
  margin: ${spacing(4)} auto ${spacing(3)} auto;
  box-shadow: 0 4px 12px rgba(111, 207, 151, 0.1);
  position: relative;
  
  /* Add a subtle glow effect */
  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: linear-gradient(135deg, rgba(111, 207, 151, 0.2), rgba(111, 207, 151, 0.1));
    border-radius: ${spacing(3)};
    z-index: -1;
    opacity: 0.6;
  }
  
  &:hover {
    background: linear-gradient(135deg, rgba(111, 207, 151, 0.18) 0%, rgba(111, 207, 151, 0.12) 100%);
    border-color: rgba(111, 207, 151, 0.4);
    box-shadow: 0 6px 16px rgba(111, 207, 151, 0.15);
  }
  
  ${MQ.NOT_TABLETS} {
    display: none;
  }
`

export const currentBalanceAmount = css`
  color: ${colors.greens.green2};
  margin: 0;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(111, 207, 151, 0.3);
  font-size: 20px;
`
